export default "__VITE_ASSET__BBG5FU26__"